exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-multiselect{width:500px}.user-multiselect .multiselect__single{font-size:.9rem}", ""]);

// exports
